import React from 'react'
import ReactDOM from 'react-dom/client'
import SpineLeafTopology from './SpineLeafTopology'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <SpineLeafTopology />
  </React.StrictMode>,
)
